export default function Beneficios() {
  return (
    <section className="px-6 md:px-8 py-8 max-w-5xl mx-auto">
      <div className="card overflow-hidden">
        <div className="bg-gray-50 border-b border-gray-200 px-5 py-3">
          <div className="text-[15px] text-gray-700">Beneficios Codelco</div>
        </div>

        <div className="px-5 md:px-6 py-6 md:py-7 text-gray-700">
          <div className="space-y-1 mb-8">
            <p className="text-[13px] font-semibold uppercase tracking-wide text-codelco">
              CONVENIO COLECTIVO DE TRABAJO 2013-2017
            </p>
            <h2 className="font-display text-2xl font-bold text-navy-600">BENEFICIOS</h2>
            <p className="text-lg font-semibold text-gray-800">Ayuda por atención dental</p>
          </div>

          <div className="space-y-6 text-[15px] leading-8">
            <p>
              La División reembolsará el 85% del valor de los gastos de atención dental
              en que deba incurrir el personal rol "A" y sus cargas familiares,
              incluyendo los tratamientos y radiografías correspondientes.
            </p>

            <p>Para el gasto en pabellón quirúrgico, se distinguen dos situaciones:</p>

            <p>
              Estos valores serán fijados de acuerdo al honorario profesional promedio,
              determi- nado conforme a la reglamentación interna establecida al efecto.
              La suma que exceda del porcentaje indicado será de cargo del beneficiario.
            </p>

            <p>
              Tendrá derecho a este beneficio el cónyuge del supervisor rol "A", aunque
              no tenga la calidad de carga familiar y quienes hayan tenido tal calidad
              respecto al supervisor y siempre que sean menores de 27 años de edad, que
              sean estudiantes, solteros y vivan a expensas del supervisor
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
